import utils from "./utils";

class ObjectForm {
  constructor(api) {
    this.api = api;
  }

  getAllWithoutFields(filters, onSuccess, onError) {
    let filter = "";
    if (filters) {
      filter = "&filter=" + filters;
    }
    return this.api.http_fibercloud
      .get("v1/objectforms/?paginate=false" + filter, {
        headers: {
          "content-language": localStorage.getItem("lang")
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByLayer(layer, tabs, fields, onSuccess, onError) {
    let include = "";
    if (tabs || fields) {
      include = "?include=";
    }
    if (tabs) include += "tabs";
    else if (fields) include += "fields";

    if(!layer) { layer = 'fc_workspace'; }
    return this.api.http_fibercloud
      .get("v1/objectforms/" + layer + include, {
        headers: {
          "content-language": localStorage.getItem("lang")
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAutomaticLabel(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/networks/labelling", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getFormFields(filters, onSuccess, onError) {
    let extras = utils.getPreparedExtras(filters);
    if (extras !== "") {
      extras = "?" + extras;
    }

    return this.api.http_fibercloud
      .get("v1/form-fields" + extras)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default ObjectForm;



// WEBPACK FOOTER //
// ./src/api/object_form.js